import React from 'react';

const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function TimeFilterPanel({
  isMobileFilterLayout = false,
  uiSize = 'medium',
  basisOptions = [],
  selectedBasis = '',
  onSelectBasis,
  rangeOptions = [],
  selectedRange = '',
  onSelectRange,
  hasActiveTimeFilter = false,
  onClear,
  monthPickerYear,
  setMonthPickerYear,
  selectedMonth = '',
  onSelectMonth,
  selectedYear = '',
  onSelectYear,
}) {
  const isMobileLargeUi = isMobileFilterLayout && uiSize === 'large';

  return (
    <div style={{
      gridColumn: '1 / -1',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '8px 10px',
      border: '1px solid color-mix(in srgb, var(--card-border) 80%, transparent)',
      borderRadius: '10px',
      background: 'color-mix(in srgb, var(--input-bg) 75%, transparent)'
    }}>
      <div className="time-filter-row time-based-row" style={{ display: 'flex', flexWrap: 'wrap', gap: isMobileLargeUi ? '3px' : (isMobileFilterLayout ? '4px' : '6px'), alignItems: 'center' }}>
        <span style={{ fontSize: 'var(--ui-subtle-font)', opacity: 0.85, minWidth: isMobileLargeUi ? '50px' : (isMobileFilterLayout ? '54px' : '64px'), fontWeight: 700, letterSpacing: '0.02em' }}>Based on</span>
        {basisOptions.map((opt) => (
          <button
            key={opt.value}
            className="btn-subtle"
            onClick={() => onSelectBasis?.(opt.value)}
            style={selectedBasis === opt.value ? {
              backgroundColor: 'color-mix(in srgb, #2b8a3e 24%, transparent)',
              color: 'var(--text-primary)',
              border: '1px solid color-mix(in srgb, #2b8a3e 60%, transparent)',
              fontSize: 'var(--ui-subtle-font)',
              padding: isMobileLargeUi ? '2px 6px' : (isMobileFilterLayout ? '2px 7px' : '3px 9px')
            } : {
              fontSize: 'var(--ui-subtle-font)',
              padding: isMobileLargeUi ? '2px 6px' : (isMobileFilterLayout ? '2px 7px' : '3px 9px'),
              border: '1px solid transparent'
            }}
          >
            {opt.label}
          </button>
        ))}
        <button
          className="btn-subtle"
          disabled={!hasActiveTimeFilter}
          onClick={onClear}
          style={{
            marginLeft: 'auto',
            fontSize: 'var(--ui-subtle-font)',
            padding: isMobileLargeUi ? '2px 6px' : (isMobileFilterLayout ? '2px 8px' : '4px 10px'),
            backgroundColor: hasActiveTimeFilter
              ? 'color-mix(in srgb, #d0d6df 58%, var(--button-bg) 42%)'
              : 'color-mix(in srgb, var(--text-muted) 16%, transparent)',
            border: hasActiveTimeFilter
              ? '1px solid color-mix(in srgb, #8b949e 72%, var(--card-border) 28%)'
              : '1px solid color-mix(in srgb, var(--text-muted) 34%, transparent)',
            color: hasActiveTimeFilter
              ? 'color-mix(in srgb, #111827 84%, var(--text-primary) 16%)'
              : 'color-mix(in srgb, var(--text-muted) 76%, var(--text-primary) 24%)',
            fontWeight: 700,
            opacity: hasActiveTimeFilter ? 1 : 0.62
          }}
        >
          ✕ Clear
        </button>
      </div>

      <div className="time-filter-row time-range-row" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center' }}>
        <span style={{ fontSize: 'var(--ui-subtle-font)', opacity: 0.85, minWidth: '64px', fontWeight: 700, letterSpacing: '0.02em' }}>Range</span>
        {rangeOptions.map((opt) => (
          <button
            key={opt.value}
            className="btn-subtle time-range-chip"
            onClick={() => onSelectRange?.(opt.value)}
            style={selectedRange === opt.value ? {
              backgroundColor: 'color-mix(in srgb, var(--text-link, #228be6) 22%, transparent)',
              color: 'var(--text-primary)',
              border: '1px solid color-mix(in srgb, var(--text-link, #228be6) 60%, transparent)',
              fontSize: 'var(--ui-subtle-font)',
              padding: opt.value === 'year' ? '2px 6px' : '2px 7px'
            } : {
              fontSize: 'var(--ui-subtle-font)',
              padding: opt.value === 'year' ? '2px 6px' : '2px 7px',
              border: '1px solid transparent'
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {selectedRange === 'month' && (
        <div
          style={{
            border: '1px solid color-mix(in srgb, var(--card-border) 85%, transparent)',
            borderRadius: '10px',
            padding: '8px',
            maxWidth: '340px'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
            <button className="btn-subtle" onClick={() => setMonthPickerYear?.((y) => y - 1)} style={{ padding: '3px 8px' }}>←</button>
            <strong style={{ fontSize: 'var(--ui-compact-font)' }}>{monthPickerYear}</strong>
            <button className="btn-subtle" onClick={() => setMonthPickerYear?.((y) => y + 1)} style={{ padding: '3px 8px' }}>→</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: '6px' }}>
            {MONTH_SHORT.map((m, idx) => {
              const value = `${monthPickerYear}-${String(idx + 1).padStart(2, '0')}`;
              const active = selectedMonth === value;
              return (
                <button
                  key={value}
                  className="btn-subtle"
                  onClick={() => onSelectMonth?.(value)}
                  style={active ? {
                    backgroundColor: 'var(--text-primary)',
                    color: 'var(--bg-card)',
                    fontSize: 'var(--ui-subtle-font)',
                    padding: '3px 6px'
                  } : {
                    fontSize: 'var(--ui-subtle-font)',
                    padding: '3px 6px'
                  }}
                >
                  {m}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {selectedRange === 'year' && (
        <div
          style={{
            border: '1px solid color-mix(in srgb, var(--card-border) 85%, transparent)',
            borderRadius: '10px',
            padding: '8px',
            width: 'fit-content',
            maxWidth: '220px'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
            <button className="btn-subtle" onClick={() => setMonthPickerYear?.((y) => y - 1)} style={{ padding: '3px 8px' }}>←</button>
            <button
              className="btn-subtle"
              onClick={() => onSelectYear?.(String(monthPickerYear))}
              style={String(monthPickerYear) === String(selectedYear) ? {
                backgroundColor: 'var(--text-primary)',
                color: 'var(--bg-card)',
                fontSize: 'var(--ui-subtle-font)',
                padding: '3px 14px'
              } : {
                fontSize: 'var(--ui-subtle-font)',
                padding: '3px 14px'
              }}
            >
              {monthPickerYear}
            </button>
            <button className="btn-subtle" onClick={() => setMonthPickerYear?.((y) => y + 1)} style={{ padding: '3px 8px' }}>→</button>
          </div>
        </div>
      )}
    </div>
  );
}
